import Icon from "../Icon";
import PopOver from "../PopOver";
import Colors from "../../constants/Colors";

type Props = {
  title: string;
  children: React.ReactNode;
  interactive?: boolean;
};

export function ContextualHelp({ children, title, interactive }: Props) {
  const content = (
    <div className="contextual-help">
      <h2>{title}</h2>
      {children}
    </div>
  );
  return (
    // @ts-expect-error TS(2322) FIXME: Type '{ children: Element; content: Element; inter... Remove this comment to see the full error message
    <PopOver content={content} interactive={interactive}>
      <div className="contextual-help-icon">
        <Icon name="lcm-iot-icon-help" color={Colors.EH_CYAN_3} />
      </div>
    </PopOver>
  );
}

export default ContextualHelp;
